<template>
  <v-container fluid class="mx-0 px-0">
    <el-overlay-loading :loading="pageloading" />
    <v-card flat class="mx-0 px-3 ntr-card-gray">
      <template v-if="isPrasymasIregistravimas">
        <template v-if="isPrasymasNuoma || isPrasymasSubnuoma">
          <v-row dense no-gutters>
            <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
              {{ $t('Mokėjimo diena')
              }}<el-need v-if="!isReadonly" /><el-tooltip
                inline
                :tooltip="`${ntrTooltipPrefix} Sutartis. Mokėjimo diena`"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                :readonly="isReadonly"
                hide-details="auto"
                validate-key="mokejimo_diena"
                v-mask="`##`"
                month-day
                v-model="sutartis.sut_mokejimo_diena"
                @blur="saveData()"
              />
            </v-col>
          </v-row>
          <v-row dense no-gutters>
            <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
              {{ $t('Banko sąskaitos numeris')
              }}<el-need v-if="!readonlyBankoSaskaita" /><el-tooltip
                inline
                :tooltip="
                  `${ntrTooltipPrefix} Sutartis. Banko sąskaitos numeris`
                "
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                :readonly="readonlyBankoSaskaita"
                hide-details="auto"
                validate-key="banko_saskaita"
                v-mask="saskaitaMask"
                placeholder="LT## ##### ###########"
                v-model="sutartis.sut_banko_saskaita"
                @blur="saveData()"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              class="mt-1 ml-5"
              v-if="showKeliosSaskaitos"
            >
              <el-checkbox
                :label="$t('Mokama į kelias banko sąskaitas')"
                :tooltip="
                  `${ntrTooltipPrefix} Sutartis. Mokama į kelias banko sąskaitas`
                "
                :readonly="isReadonly"
                validate-key="kelios_saskaitos"
                v-model="keliosSaskaitos"
                @click.native="saveData()"
              />
            </v-col>
          </v-row>
          <v-row dense no-gutters v-if="showMokejimoInformacija">
            <v-col cols="12" md="12" class="mt-5">
              <el-textarea
                :readonly="isReadonly"
                need
                class="no-color-label"
                :label="$t('Kita su mokėjimu susijusi informacija')"
                :tooltip="
                  `${ntrTooltipPrefix} Sutartis. Kita su mokėjimu susijusi informacija`
                "
                counter="4000"
                hide-details="auto"
                validate-key="mokejimo_informacija"
                v-model="sutartis.sut_mokejimo_informacija"
                @blur="saveData()"
              />
            </v-col>
          </v-row>
          <v-row dense no-gutters>
            <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
              {{ $t('Užstato dydis')
              }}<el-need
                v-if="!isReadonly && !disabledUzstatoDydis"
              /><el-tooltip
                inline
                :tooltip="`${ntrTooltipPrefix} Sutartis. Užstato dydis`"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                :disabled="disabledUzstatoDydis"
                :readonly="isReadonly"
                hide-details="auto"
                v-mask="`##`"
                validate-key="uzstato_dydis"
                v-model="sutartis.sut_uzstato_dydis"
                @blur="saveData()"
              >
                <template slot="append-outer">
                  <div class="mt-2 nowrap no-color-label">
                    {{ $t('mėnesių sk.') }}
                  </div>
                </template>
              </el-text-field>
            </v-col>
            <v-col cols="12" md="1" class="mt-3 ml-5">
              <el-checkbox
                :label="$t('Nenumatyta')"
                :tooltip="`${ntrTooltipPrefix} Sutartis. Nenumatyta`"
                :readonly="isReadonly"
                validate-key="nenumatyta"
                v-model="sutartis.sut_nenumatyta"
                @click.native="saveData()"
              />
            </v-col>
          </v-row>
        </template>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ terminasNuoLabel }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${terminasNuoTooltip}`"
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-date-picker
              :readonly="isReadonly"
              hide-details="auto"
              future-dates
              validate-key="terminas_nuo"
              v-model="sutartis.sut_terminas_nuo"
              @blur="saveData()"
            >
              <template slot="prepend">
                <div class="mt-2 no-color-label">{{ $t('nuo') }}</div>
              </template>
            </el-date-picker>
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-date-picker
              :disabled="disabledTerminasIki"
              :readonly="isReadonly"
              hide-details="auto"
              validate-key="terminas_iki"
              future-dates
              :threshold="sutartis.sut_terminas_nuo"
              v-model="sutartis.sut_terminas_iki"
              @blur="saveData()"
            >
              <template slot="prepend">
                <div class="mt-2 no-color-label">{{ $t('iki') }}</div>
              </template>
            </el-date-picker>
          </v-col>
          <v-col cols="12" md="1" class="mt-3">
            <el-checkbox
              :label="$t('Neterminuota')"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Neterminuota`"
              :readonly="isReadonly"
              validate-key="neterminuota"
              v-model="sutartis.sut_neterminuota"
              @click.native="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col
            :class="`bold-label pt-4 ${perdavimoDataLabelFix}`"
            cols="12"
            md="4"
            align-self="center"
          >
            {{ perdavimoDataLabel }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${perdavimoDataTooltip}`"
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-date-picker
              :readonly="isReadonly"
              hide-details="auto"
              validate-key="perdavimo_data"
              v-model="sutartis.sut_perdavimo_data"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Įspėjimas apie sutarties nutraukimą')
            }}<el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Įspėjimas apie sutarties nutraukimą`
              "
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :readonly="isReadonly"
              hide-details="auto"
              v-mask="`##`"
              validate-key="sut_nutraukimo_ispejimas"
              v-model="sutartis.sut_nutraukimo_ispejimas"
              @blur="saveData()"
            >
              <template slot="append-outer">
                <div class="mt-2 nowrap no-color-label">
                  {{ $t('mėnesių sk.') }}
                </div>
              </template>
            </el-text-field>
          </v-col>
        </v-row>
        <v-row dense no-gutters v-if="sutartis.sut_komunaliniai_show">
          <v-col cols="12" md="12">
            <el-checkbox
              :label="komunaliniaiLabel"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Komunaliniai mokesčiai`"
              class="mt-3"
              :readonly="isReadonly"
              validate-key="komunaliniai"
              v-model="sutartis.sut_komunaliniai"
              @click.native="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Veiklos aprašymas')"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Veiklos aprašymas`"
              :need="sutartis.sut_aprasymas_required"
              counter="4000"
              hide-details="auto"
              validate-key="aprasymas"
              v-model="sutartis.sut_aprasymas"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Kiti įsipareigojimai')"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Kiti įsipareigojimai`"
              counter="4000"
              hide-details="auto"
              validate-key="isipareigojimai"
              v-model="sutartis.sut_isipareigojimai"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Kiti nutraukimo pagrindai')"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kiti nutraukimo pagrindai`
              "
              counter="4000"
              hide-details="auto"
              validate-key="nutraukimo_pagrindai"
              v-model="sutartis.sut_nutraukimo_pagrindai"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
      </template>

      <template v-if="!isPrasymasIregistravimas">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t(' Sutarties numeris')
            }}<el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties numeris`"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="sut_numeris"
              v-model="sutartis.sut_numeris"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ sutartisDataLabel
            }}<el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${sutartisDataTooltip}`"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="sut_data"
              v-model="sutartis.sut_data"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters v-if="isPrasymasIsregistravimas">
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Sutarties pabaigos data')
            }}<el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties pabaigos data`"
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="sut_pabaigos_data"
              v-model="sutartis.sut_pabaigos_data"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters v-if="isPrasymasNutraukimas">
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Sutarties nutraukimo data')
            }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties nutraukimo data`
              "
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-date-picker
              :readonly="isReadonly"
              hide-details="auto"
              validate-key="sut_nutraukimo_data"
              v-model="sutartis.sut_nutraukimo_data"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
      </template>

      <v-row
        dense
        no-gutters
        v-if="isPrasymasIregistravimas || isPrasymasNutraukimas"
      >
        <v-col cols="12" md="12" class="mt-5">
          <el-textarea
            :readonly="isReadonly"
            class="no-color-label"
            :label="sutartiesSalygosLabel"
            :tooltip="sutartiesSalygosTooltip"
            counter="4000"
            hide-details="auto"
            validate-key="salygos"
            v-model="sutartis.sut_salygos"
            @blur="saveData()"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'PrasymasSutartis',
  props: {
    readonly: { type: Boolean, default: false },
  },
  mixins: [userRole, busena, tooltipNtr, checkErrors],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      sutartis: {},
      keliosSaskaitos: null,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    isReadonly() {
      return this.readonly
    },
    saskaitaMask() {
      return 'AA## ##### ###########'
    },
    disabledUzstatoDydis() {
      return this.sutartis.sut_nenumatyta
    },
    disabledTerminasIki() {
      return this.sutartis.sut_neterminuota
    },
    terminasNuoLabel() {
      if (this.isPrasymasPanauda) {
        return this.$t('Panaudos sutarties terminas')
      }
      if (this.isPrasymasSubnuoma) {
        return this.$t('Subnuomos sutarties terminas')
      }
      return this.$t('Nuomos sutarties terminas')
    },
    terminasNuoTooltip() {
      if (this.isPrasymasPanauda) {
        return 'Panaudos sutarties terminas'
      }
      if (this.isPrasymasSubnuoma) {
        return 'Subnuomos sutarties terminas'
      }
      return 'Nuomos sutarties terminas'
    },
    perdavimoDataLabel() {
      if (this.isPrasymasPanauda) {
        return this.$t('Daikto perdavimo panaudos gavėjui data')
      }
      if (this.isPrasymasSubnuoma) {
        return this.$t('Daikto perdavimo subnuomininkui data')
      }
      return this.$t('Daikto perdavimo nuomininkui data')
    },
    perdavimoDataLabelFix() {
      if (this.isPrasymasSubnuoma) {
        return 'pr-4'
      }
      return ''
    },
    perdavimoDataTooltip() {
      if (this.isPrasymasPanauda) {
        return 'Daikto perdavimo panaudos gavėjui data'
      }
      if (this.isPrasymasSubnuoma) {
        return 'Daikto perdavimo subnuomininkui data'
      }
      return 'Daikto perdavimo nuomininkui data'
    },
    komunaliniaiLabel() {
      if (this.isPrasymasPanauda) {
        return this.$t(
          'Panaudos gavėjas kiekvieną mėnesį panaudos davėjui moka / atlygina Nekilnojamojo daikto komunalinius mokesčius'
        )
      }
      if (this.isPrasymasSubnuoma) {
        return this.$t(
          'Subnuomininkas kiekvieną mėnesį subnuomotojui moka / atlygina Nekilnojamojo daikto komunalinius mokesčius'
        )
      }
      return this.$t(
        'Nuomininkas kiekvieną mėnesį Nuomotojui moka / atlygina Nekilnojamojo daikto komunalinius mokesčius'
      )
    },
    sutartisDataLabel() {
      if (this.isPrasymasIsregistravimas) {
        return this.$t('Sutarties pradžios data')
      }
      return this.$t('Sutarties data')
    },
    sutartisDataTooltip() {
      if (this.isPrasymasIsregistravimas) {
        return 'Sutarties pradžios data'
      }
      return 'Sutarties data'
    },
    sutartiesSalygosLabel() {
      if (this.isPrasymasNutraukimas) {
        return this.$t('Kitos susitarimo sąlygos')
      }
      return this.$t('Kitos šalių numatytos sutarties sąlygos')
    },
    sutartiesSalygosTooltip() {
      if (this.isPrasymasNutraukimas) {
        return `${this.ntrTooltipPrefix} Sutartis. Kitos susitarimo sąlygos`
      }
      return `${this.ntrTooltipPrefix} Sutartis. Kitos šalių numatytos sutarties sąlygos`
    },
    showKeliosSaskaitos() {
      return this.isPrasymasSubnuoma
    },
    showMokejimoInformacija() {
      return this.keliosSaskaitos
    },
    readonlyBankoSaskaita() {
      return this.isReadonly || this.keliosSaskaitos
    },
  },
  watch: {
    keliosSaskaitos(val) {
      this.sutartis.sut_kelios_saskaitos = !!val
      if (val) {
        this.sutartis.sut_banko_saskaita = null
      }
      if (!val) {
        this.sutartis.sut_mokejimo_informacija = null
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`)
        .then(res => {
          this.sutartis = res.data.sutartis
          this.$nextTick(() => {
            this.keliosSaskaitos = this.sutartis.sut_kelios_saskaitos
          })
          this.updateErrors()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      if (this.isReadonly) {
        return
      }
      if (this.sutartis.sut_neterminuota) {
        this.sutartis.sut_terminas_iki = null
      }
      if (this.sutartis.sut_nenumatyta) {
        this.sutartis.sut_uzstato_dydis = null
      }
      this.$validator.validateAll().then(res => {
        if (res) {
          const data = {
            ...this.sutartis,
          }
          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`, data)
            .then(res => {
              this.updateErrors()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
